'use strict';

module.exports = typeof Promise === 'function' ? Promise : require('pinkie');



//////////////////
// WEBPACK FOOTER
// ./node_modules/pinkie-promise/index.js
// module id = wuKq
// module chunks = 0